<template>
  <section>
    
    <h1 class="section-head">รายละเอียดลูกค้า: {{ customer.name }} </h1>
    <nav class="level">
      <div class="level-left">
        <div class="level-item">
          <router-link class="button is-danger is-pulled-left" to="/customer"><i class="fas fa-arrow-left"></i>กลับ</router-link>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div class="buttons">
            <router-link class="button is-info is-pulled-right" :to="('/purchaseorder/add/'+this.$route.params.id)" v-can="'add_po'"><i class="fas fa-clipboard-list"></i>สั่งสินค้าจากลูกค้า</router-link>
          </div>
        </div>
      </div>
    </nav>

    <div class="content">
      <h3 class="header-line"><strong>{{customer.name}}</strong> <router-link class="button is-warning is-small" :to="('/customer/edit/'+this.$route.params.id)" v-can="'edit_customer'"><i class="fas fa-pencil-alt"></i>แก้ไข</router-link></h3>
    </div>

    <div class="columns">
      <div class="column">

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ที่อยู่</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="ที่อยู่" v-model="this.customer.address" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-map-marker-alt"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">เบอร์โทรศัพท์</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="เบอร์โทรศัพท์" v-model="this.customer.phone" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-phone"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Fax.</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="Fax." v-model="this.customer.fax" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-phone"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">เลขผู้เสียภาษี</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="เลขผู้เสียภาษี" v-model="this.customer.tax_no" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
          
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">E-Mail</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="E-Mail" v-model="this.customer.email" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
              </p>
            </div>
          </div>
        </div>
          
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">ประเภทลูกค้า</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control has-icons-left">
                <input class="input is-static" type="text" placeholder="E-Mail" :value="this.customer.type == 'other' ? 'ทั่วไป':'Pestguard Group'" readonly>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
          </div>
        </div>


        


      </div>

    </div>

  </section>
</template>

<script>
  import Request from '@/libraries/request';
  import CustomerModel from '@/model/customer_model';

  export default {
    name: "Customer_view",
    data() {
      return {
        customer: {
          name: "",
          address: "",
          phone: "",
          email: "",
          tax_no: "",
          fax: "",
        },
        isLoading: true
      }
    },
    created() {
      this.get_customer();
    },
    methods: {
      async get_customer() {
        if(this.$route.params.id == 'undefined'){
          this.$buefy.snackbar.open('Customer ID not found.');
          this.$router.push('/customer');
        }else{
          try{
            const customer = await CustomerModel.get_customer(this.$route.params.id);
            this.customer = customer;
            this.isLoading = false;
          }catch(e){
            this.$buefy.snackbar.open(e.message);
            this.$router.push('/customer');
          }
        }
      }
    }
  }
</script>

<style lang="scss">
.header-line {
  border-bottom: 1px solid #C7C7C7;
  padding-bottom: 0.25rem;
}
</style>




// WEBPACK FOOTER //
// src/pages/Customer/view.vue